module.exports = "<ion-app class=\"smartphone\" scroll=\"false\">\r\n  <ion-router-outlet main></ion-router-outlet>\r\n</ion-app>"